<template>
  <div id="container">
    <div class="box-content-title">
      <div class="title-font-style">
        <span>提现记录</span>
      </div>
    </div>
    <el-form class="search-style">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.column" @change="changeQueryParams">
              <el-option
                v-for="(item, index) in financePayCondition"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.expression" v-show="queryParams.column === 'amount'">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in expressionList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-select v-model="queryParams.value" v-if="queryParams.column === 'state'">
              <el-option label="提现审核" :value="1"></el-option>
              <el-option label="提现成功" :value="5"></el-option>
              <el-option label="审核不通过" :value="3"></el-option>
              <el-option label="退回修改" :value="4"></el-option>
              <el-option label="付款失败" :value="6"></el-option>
            </el-select>
            <el-date-picker
              style="width:100%"
              v-else-if="queryParams.column === 'createDate' || queryParams.column === 'processSecDate'"
              v-model="time"
              :default-time="['00:00:00','23:59:59']"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <el-input v-model="queryParams.value" placeholder="请输入关键词" v-else></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-show="false">
          <el-form-item>
            <el-input v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button plain @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        :max-height="$store.state.Sell.heightTitle"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="付款编号" fixed show-overflow-tooltip min-width="150">
          <template slot-scope="scope">
            <span class="approval" @click="onSee(scope.row)">{{ scope.row.payNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" fixed show-overflow-tooltip min-width="180">
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="onCusName(scope.row)"
            >{{ scope.row.cusName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="提现金额">
          <template slot-scope="scope">{{ scope.row.amount | priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="beforPayAmount" label="提现前余额">
          <template slot-scope="scope">{{ scope.row.beforPayAmount | priceFilter }}</template>
        </el-table-column>
        <el-table-column prop="afterPayAmount" label="提现后金额">
          <template slot-scope="scope">{{ scope.row.afterPayAmount | priceFilter }}</template>
        </el-table-column>
        <el-table-column label="提现状态" min-width="120">
          <template slot-scope="scope">
            <span
              v-if="scope.row.stateName === '审核不通过'||scope.row.stateName === '退回修改'"
              style="color:#D35E5E"
            >{{scope.row.stateName}}</span>
            <span v-else>{{scope.row.stateName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="发起人"></el-table-column>
        <el-table-column label="发起时间" min-width="125">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate | dateFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="processSecUser" label="转账处理人" min-width="100px"></el-table-column>
        <el-table-column label="处理时间" min-width="125">
          <template slot-scope="scope">
            <span>{{ scope.row.processSecDate | dateFilterL }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="onSee(scope.row)">查看</el-button>
            <el-button
              @click="onInitiateWithdrawal(scope.row)"
              type="text"
              v-if="scope.row.stateName==='审核不通过'&&scope.row.isInitiate===0"
            >重新发起</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { financePayCondition } from './util/data'
import { expressionList } from '@/components/utils/data'
import { financePayQueryByOwnId } from '@/api/sell/sellManage'
import pagination from '@/components/pagination'
export default {
  components: { pagination },
  data () {
    return {
      columnArr: [],
      financePayCondition,
      queryParams: {
        column: 'cusName'
      },
      time: [],
      expressionList,
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    onCusName (row) {
      this.$router.push({ name: 'customer/details', query: { id: row.cid } })
    },
    onSearch () {
      if (this.time.length === 2) {
        this.queryParams.value = this.time[0]
        this.queryParams.endValue = this.time[1]
      }
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset () {
      // 重置
      this.columnArr = []
      this.time = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    getList () {
      this.loadingTable = true
      this.queryParams.collection = true
      const params = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      financePayQueryByOwnId(0, this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changeQueryParams (val) {
      this.queryParams = {}
      this.queryParams.column = val
      if (val === 'amount') {
        this.$set(this.queryParams, 'expression', 'eq')
      }
      this.time = []
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 重新提现
    onInitiateWithdrawal (row) {
      this.$router.push({
        name: 'initiateWithdrawal',
        query: { cusId: row.cid, cwaId: row.cwaId }
      })
    },
    // 查看
    onSee (row) {
      this.$router.push({
        name: 'withdrawalDetails',
        query: { pay: row.payNumber, type: row.payType }
      })
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
